import React from "react";

import cn from "classnames";

import { boxForwardRef } from "../../../../../../helpers/common/Box/Box";
import { TextCore } from "../../../../../../helpers/common/TextCore/TextCore";
import { SUBTITLE_MIXIN_BY_HEADER_SIZE_MAP } from "../../constants/sizes";
import { createDisplayNameForCoreHeader } from "../../utils/createDisplayName";
import { createTestIdForCoreHeader } from "../../utils/createTestId";

import type { BoxComponentWithDefault } from "../../../../../../helpers/common/Box/Box";
import type {
    OmitOfUnion,
    PropsWithViewNever,
} from "../../../../../../types/react";
import type { CoreHeaderSize, CoreHeaderTextProps } from "../../types";

import classes from "./CoreHeaderSubtitle.styl";

const SUBTITLE_TEST_ID = createTestIdForCoreHeader("subtitle");

type CoreHeaderSubtitleProps = PropsWithViewNever<
    OmitOfUnion<CoreHeaderTextProps, "width" | "quote" | "asList"> & {
        size?: CoreHeaderSize;
    }
>;

export const CoreHeaderSubtitle = boxForwardRef<
    BoxComponentWithDefault<"span", CoreHeaderSubtitleProps>
>(
    (
        {
            size,
            children,
            view,
            customColorsStyles,
            customVarsStyles,
            "data-tsid": tsid = SUBTITLE_TEST_ID,
            ...props
        },
        ref,
    ) => {
        const subtitleStyles = cn(
            classes["subtitle"],
            classes[`__view-${view!}`],
        );

        return children ? (
            <TextCore
                {...props}
                typographyStyle={
                    size && SUBTITLE_MIXIN_BY_HEADER_SIZE_MAP[size]
                }
                textContainerClassName={subtitleStyles}
                customVarsStyles={cn(customVarsStyles, customColorsStyles)}
                data-tsid={tsid}
                ref={ref}
            >
                {children}
            </TextCore>
        ) : null;
    },
);

CoreHeaderSubtitle.displayName = createDisplayNameForCoreHeader("Subtitle");

export default CoreHeaderSubtitle;
